import { defineComponent as c, createElementBlock as u, openBlock as g, mergeProps as b, unref as e, createElementVNode as r, normalizeClass as t, createVNode as n, withCtx as L } from "vue";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DataList/data-list.js";
import { useOUIAProps as C } from "../../helpers/ouia.js";
import y from "../Button.vue2.js";
import { AngleRightIcon as I } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
const T = /* @__PURE__ */ c({
  name: "PfDataListToggle",
  __name: "DataListToggle",
  props: {
    id: {},
    expanded: { type: Boolean },
    noPadding: { type: Boolean },
    ariaLabelledby: {},
    ariaLabel: { default: "Details" },
    ariaControls: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click"],
  setup(s, { emit: d }) {
    const i = s, p = C({ id: i.ouiaId, safe: i.ouiaSafe }), m = d;
    return (a, l) => (g(), u("div", b(e(p), {
      class: e(o).dataListItemControl
    }), [
      r("div", {
        class: t(e(o).dataListToggle)
      }, [
        n(y, {
          id: a.id,
          variant: "plain",
          "aria-controls": a.ariaControls && a.ariaControls,
          "aria-label": a.ariaLabel,
          "aria-labelledby": a.ariaLabel !== "Details" ? void 0 : a.id,
          "aria-expanded": a.expanded,
          onClick: l[0] || (l[0] = (f) => m("click", f))
        }, {
          default: L(() => [
            r("div", {
              class: t(e(o).dataListToggleIcon)
            }, [
              n(e(I))
            ], 2)
          ]),
          _: 1
        }, 8, ["id", "aria-controls", "aria-label", "aria-labelledby", "aria-expanded"])
      ], 2)
    ], 16));
  }
});
export {
  T as default
};
